// extracted by mini-css-extract-plugin
export default {"liveVideoFeed":"i7lpDuGoQ1JmWpNmUDkH","videoFrame":"X8Og0mHm0MG1MoeloKiT","mirror":"ZOwL2TGJPEpEdnmlN0ZN"};